import { render, staticRenderFns } from "./TreatyOutstandingClaims.vue?vue&type=template&id=47bda8ef&"
import script from "./TreatyOutstandingClaims.vue?vue&type=script&lang=js&"
export * from "./TreatyOutstandingClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports